// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3ekN4","open":"open___2MpR3","back":"back___2euxa","img":"img___3nPV-"};